<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="Name" label="名称" width="">
        </el-table-column>
        <el-table-column prop="DepartmentName" label="部门" width="">
        </el-table-column>

        <el-table-column prop="BeginValue" label="区间起始值" width="">
        </el-table-column>
        <el-table-column prop="EndValue" label="区间终止值" width="">
        </el-table-column>
        <el-table-column prop="Sort" label="顺序号" width="">
        </el-table-column>
      </el-table>
      </div>

      <!--编辑界面-->
      <el-dialog title="编辑体温区间信息" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">

          <el-form-item label="名称" prop="Name">
            <el-input v-model="editForm.Name" auto-complete="off"  :readonly="true"></el-input>
          </el-form-item>

          <el-form-item label="区间起始值" prop="BeginValue">
            <el-input-number v-model="editForm.BeginValue" :min="0" :controls="true" :step="0.1"></el-input-number>
          </el-form-item>

          <el-form-item label="区间终止值" prop="EndValue">
            <el-input-number v-model="editForm.EndValue" :min="0" :controls="true" :step="0.1"></el-input-number>
          </el-form-item>

          <el-form-item label="序号" prop="Sort">
            <el-input-number v-model="editForm.Sort"></el-input-number>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>
    </section>

  </section>

</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getTemperatureRangeListPage, editTemperatureRange } from '../../api/modules/misc';
import { getTeachingDepartmentTree } from '../../api/modules/department';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import es from "@/lang/es";

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '名称',
          key: 'name',
        },
      ],
      users: [],
      roles: [],
      options: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        BeginValue: [
          { required: true, message: "请输入起始值", trigger: "blur" },
        ],
        EndValue: [
          { required: true, message: "请输入终止值", trigger: "blur" },
        ],
        Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        BeginValue: 0,
        EndValue: 0,
        Sort: 0,
        Dids: [],
        DepartmentId: 0,
      },
      isResouceShow: 0,
      DepartmentId: 0,
      currentUserId: '',
      imageUrl: '',
      imageLoadding: false
    };
  },
  methods: {
    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
      let para = {
        id: this.DepartmentId,
      };
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      let para = {
        departmentId: this.DepartmentId,
        ...this.filters,
      }
      this.listLoading = true;
      testapi();
      getTemperatureRangeListPage(para).then((res) => {
        this.users = res.data.response;
        this.listLoading = false;
      });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      this.options = [];
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      // 按顶部固定学校/左侧选中部门加载树，避免总平台/其他学校。最后更新：2026-08-29
      const schoolId = this.$store.state.activeSchoolId
        || window.localStorage.getItem('activeSchoolId')
        || this.DepartmentId;
      if (!schoolId || Number(schoolId) <= 0) {
        this.$message.warning("请先选择学校");
        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      let para = { pid: 0, type: 1, scopeDepartmentId: schoolId };
      getTeachingDepartmentTree(para).then((res) => {
        ++this.isResouceShow;
        const root = res.data && res.data.response;
        this.options = root ? [root] : [];
      });
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            editTemperatureRange(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.options = [];
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },

  },
  mounted() {

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}
</style>
